var map = {
	"./Interactivity.svg": "c9f2",
	"./access.svg": "79f1",
	"./add.svg": "76a4",
	"./arrow-right-bar-right.svg": "70da",
	"./avatarNotFound.svg": "06cf",
	"./badge.svg": "81c9",
	"./book-open.svg": "4679",
	"./book.svg": "fc4e",
	"./bubbles.svg": "e66c",
	"./button/add.svg": "bede",
	"./button/edit.svg": "9bf3",
	"./button/save.svg": "a339",
	"./card-level.svg": "6d83",
	"./certificate.svg": "3f13",
	"./chalkboard-teacher.svg": "da4c",
	"./clip.svg": "9d0f",
	"./clock.svg": "755b",
	"./close.svg": "8b1b",
	"./coins.svg": "40ac",
	"./doc.svg": "3f7d",
	"./download.svg": "f28e",
	"./edit.svg": "daf0",
	"./emoji.svg": "9325",
	"./file.svg": "a147",
	"./film.svg": "0750",
	"./filter.svg": "2376",
	"./folder-tree.svg": "59a9",
	"./gallery_thumbnail.svg": "7a2e",
	"./game.svg": "dfde",
	"./gift.svg": "fb5c",
	"./groups.svg": "e6a8",
	"./icon_document.svg": "5e55",
	"./icon_game.svg": "a3f5",
	"./icon_multimedia.svg": "5e18",
	"./icon_quiz.svg": "0e7a",
	"./image.svg": "931c",
	"./info_cicle.svg": "5b37",
	"./location_arrow.svg": "65f6",
	"./logout.svg": "69e3",
	"./media_video.svg": "477a",
	"./menu/dark_icon/chat.svg": "e8b5b",
	"./menu/dark_icon/company.svg": "7d90",
	"./menu/dark_icon/dashboard.svg": "ae24",
	"./menu/dark_icon/data.svg": "f5c1",
	"./menu/dark_icon/favorites.svg": "374c",
	"./menu/dark_icon/groups.svg": "5629",
	"./menu/dark_icon/history.svg": "419e",
	"./menu/dark_icon/home.svg": "aad0",
	"./menu/dark_icon/joystick.svg": "46ae",
	"./menu/dark_icon/knowledge.svg": "3e6f",
	"./menu/dark_icon/links.svg": "a44c",
	"./menu/dark_icon/logout.svg": "e162",
	"./menu/dark_icon/message.svg": "6beb",
	"./menu/dark_icon/report.svg": "5b8e",
	"./menu/dark_icon/users.svg": "5e37",
	"./menu/dark_icon/wiki.svg": "4159",
	"./menu/white_icon/chat.svg": "eb16",
	"./menu/white_icon/company.svg": "5f83",
	"./menu/white_icon/dashboard.svg": "ff78",
	"./menu/white_icon/data.svg": "721c",
	"./menu/white_icon/favorites.svg": "ef3d",
	"./menu/white_icon/groups.svg": "c090",
	"./menu/white_icon/history.svg": "68ca",
	"./menu/white_icon/home.svg": "a0a5",
	"./menu/white_icon/joystick.svg": "efa3",
	"./menu/white_icon/knowledge.svg": "730d",
	"./menu/white_icon/links.svg": "f1df",
	"./menu/white_icon/report.svg": "85bd",
	"./menu/white_icon/users.svg": "4a3c",
	"./menu/white_icon/wiki.svg": "3957",
	"./message.svg": "612e",
	"./multiple-user.svg": "a6e0",
	"./paperclip.svg": "b308",
	"./pdf.svg": "5730",
	"./pen.svg": "6492",
	"./person.svg": "d104",
	"./plus.svg": "eb38",
	"./save.svg": "9344",
	"./send-arrow.svg": "76e4",
	"./shopping_bag.svg": "bb0d",
	"./store.svg": "e29b",
	"./survey.svg": "927d",
	"./tag.svg": "81fd",
	"./teacher.svg": "6de4",
	"./training-icon.svg": "5710",
	"./users.svg": "d956",
	"./video.svg": "512b",
	"./video_camera_front.svg": "8e3f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";